<template>
  <div>
    <div id="sidebar" v-if="['rewardmanager'].includes($route.name)" class="sub-sidebar">
      <ul class="side-menu sub-side-menu" :class="{'side-menu-campaign-detail': ['edit-campaign','create-campaign'].includes($route.name)}">
        <li v-if="userCapable" class="side-menu-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
          <i class="fas fa-award"></i> <span >Earned Rewards</span>
        </li>
        <li v-if="userCapable" class="side-menu-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
          <i class="fas fa-medal"></i> <span >Redeemed Rewards</span>
        </li>
        <li v-if="userCapable"  class="side-menu-item" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
          <i class="fas fa-chart-bar"></i> <span >Expires Soon</span>
        </li>
      </ul>
    </div>

    <div class="workspace">
    <div class="section-heading">
      <h2>Reward Manager</h2>
    </div>
    <div class="flex-area">
      <div class="tab-inner-left">
        <div class="form-module">
          <div class="w-full" v-if="activeTab === 0">

            <div class="coupon-reg">
              <h3>Reward Registration</h3>
              <p>Enter your customer's reward code below and click <strong>Register Code</strong> button.</p>
              <div class="coupon-reg-inner">
                <div class="cr-col">
                  <input class="al-input" type="text" v-model="code" placeholder="Enter code here..." /></div>
                <div class="cr-col al-button small-padding" @click="registerCode">Register Code</div>
              </div>
            </div>
            <b-modal id="modal-scrollable" v-model="result" title="Reward Details" hide-footer>
              <template #modal-header-close>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <g clip-path="url(#clip0_143_787)">
                    <path d="M11 0.34375C5.11328 0.34375 0.34375 5.11328 0.34375 11C0.34375 16.8867 5.11328 21.6562 11 21.6562C16.8867 21.6562 21.6562 16.8867 21.6562 11C21.6562 5.11328 16.8867 0.34375 11 0.34375ZM16.225 13.7973C16.427 13.9992 16.427 14.3258 16.225 14.5277L14.5234 16.225C14.3215 16.427 13.9949 16.427 13.793 16.225L11 13.4062L8.20273 16.225C8.00078 16.427 7.67422 16.427 7.47227 16.225L5.775 14.5234C5.57305 14.3215 5.57305 13.9949 5.775 13.793L8.59375 11L5.775 8.20273C5.57305 8.00078 5.57305 7.67422 5.775 7.47227L7.47656 5.7707C7.67852 5.56875 8.00508 5.56875 8.20703 5.7707L11 8.59375L13.7973 5.775C13.9992 5.57305 14.3258 5.57305 14.5277 5.775L16.2293 7.47656C16.4312 7.67852 16.4312 8.00508 16.2293 8.20703L13.4062 11L16.225 13.7973Z" fill="#F08028"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_143_787">
                      <rect width="22" height="22" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </template>
              <div  v-if="result" :class="success ? 'success' : 'denied'" class="rgd-box">
                <div v-if="success" class="status">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                      <path d="M35 19C35 27.8387 27.8387 35 19 35C10.1613 35 3 27.8387 3 19C3 10.1613 10.1613 3 19 3C27.8387 3 35 10.1613 35 19ZM17.1484 27.471L29.0194 15.6C29.4194 15.2 29.4194 14.5419 29.0194 14.1419L27.5613 12.6839C27.1613 12.2839 26.5032 12.2839 26.1032 12.6839L16.4194 22.3613L11.8968 17.8387C11.4968 17.4387 10.8387 17.4387 10.4387 17.8387L8.98064 19.2968C8.58064 19.6968 8.58064 20.3548 8.98064 20.7548L15.6903 27.4645C16.0903 27.8645 16.7484 27.8645 17.1484 27.4645V27.471Z" fill="#6ACC74"/>
                    </svg>
                  </div>
                  <h3 class="rgd-box-head"> Coupon Successfully Registered!</h3>
                </div>
                <div v-else class="status">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                      <path d="M17 1.01562C8.16992 1.01562 1.01562 8.16992 1.01562 17C1.01562 25.8301 8.16992 32.9844 17 32.9844C25.8301 32.9844 32.9844 25.8301 32.9844 17C32.9844 8.16992 25.8301 1.01562 17 1.01562ZM24.8375 21.1959C25.1404 21.4988 25.1404 21.9887 24.8375 22.2916L22.2852 24.8375C21.9822 25.1404 21.4924 25.1404 21.1895 24.8375L17 20.6094L12.8041 24.8375C12.5012 25.1404 12.0113 25.1404 11.7084 24.8375L9.1625 22.2852C8.85957 21.9822 8.85957 21.4924 9.1625 21.1895L13.3906 17L9.1625 12.8041C8.85957 12.5012 8.85957 12.0113 9.1625 11.7084L11.7148 9.15606C12.0178 8.85313 12.5076 8.85313 12.8105 9.15606L17 13.3906L21.1959 9.1625C21.4988 8.85957 21.9887 8.85957 22.2916 9.1625L24.8439 11.7148C25.1469 12.0178 25.1469 12.5076 24.8439 12.8105L20.6094 17L24.8375 21.1959Z" fill="#F26464"/>
                    </svg>
                  </div>

                  <h3 class="rgd-box-head denied"> {{ message }}</h3>
                </div>


                <div class="rgd-box-inner">
<!--                  <div class="flex"><span class="ml-2" style="line-height: 2.25">{{ result_type }}</span></div>-->
                  <div class="rd-table-cont">
                    <div class="rd-table-row">
                      <div class="rd-table-col rd-head">Reward</div>
                      <div class="rd-table-col rd-text">{{result.data.prize.name}}</div>
                    </div>
                    <div class="rd-table-row">
                      <div class="rd-table-col rd-head">Coupon Code</div>
                      <div class="rd-table-col rd-text">{{ result.data.prize.code }}</div>
                    </div>
                    <div class="rd-table-row">
                      <div class="rd-table-col rd-head">Earned Date</div>
                      <div class="rd-table-col rd-text">{{ result.data.earned_date }}</div>
                    </div>
                    <div class="rd-table-row">
                      <div class="rd-table-col rd-head ">Registered Date</div>
                      <div class="rd-table-col rd-text">{{ registered_date }}</div>
                    </div>
                    <div class="rd-table-row" v-for="(line, index) in result.data.info" :key="index" v-if="line[Object.keys(line)[0]]">
                      <div class="rd-table-col rd-head">Customer {{firstLetterCapitalize(Object.keys(line)[0])}}</div>
                      <div class="rd-table-col rd-text">{{ line[Object.keys(line)[0]] }}</div>
                    </div>
                  </div>
                </div>
              </div>

            </b-modal>

            <earned-rewards />
          </div>

          <div class="w-full" v-else-if="activeTab === 1">
            <redeemed-rewards />
          </div>
          <div class="w-full" v-else>
      <expires-soon />
    </div>
        </div>
      </div>

    </div>
  </div>
  </div>
</template>
<script>

import EarnedRewards from './components/EarnedRewards'
import RedeemedRewards from './components/RedeemedRewards'
import ExpiresSoon from './components/ExpiresSoon'
import moment from 'moment'
export default {
  components: {
    EarnedRewards,
    RedeemedRewards,
    ExpiresSoon
  },
  metaInfo () {
    return {
      title: 'Reward Manager',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Manage your rewards'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  data () {
    return {
      create: true,
      code: '',
      result: false,
      success: false,
      type: 'interaction',
      activeTab: 0,
      message: null
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    userCapable () {
      let result = true
      this.activeUserInfo.subscriptions.map(sub => {
        if (sub.plan.product.id === 'prod_LxaiP3NvLRaWld') {
          result = true
        }
      })
      return result
    },
    result_type () {
      let result = 'Form Submit'
      if (this.result.type === 'prize') {
        result = 'Scratch-off Prize'
      }
      return result
    },
    reward_code () {
      if (this.type === 'prize') {
        return this.result.data.prize.code
      } else {
        return this.result.data.code
      }
    },
    registered_date () {
      if (this.type === 'prize') {
        return this.result.data.prize.registered_date
      } else {
        return this.result.data.registered_date
      }
    }
  },
  methods: {
    formatDate (str) {
      moment(new Date(str)).format('L')
    },
    registerCode () {
      const payload = {
        code: this.code
      }
      this.$store.dispatch('registerCode', payload)
        .then((response) => {
          const result = response.data
          this.result = result.data
          console.log('success', this.result)
          this.success = this.result.success
          this.type = this.result.type
          this.message = result.message
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    firstLetterCapitalize (str) {
      return str.substring(0, 1).toUpperCase().concat(str.substring(1))
    }
  }
}
</script>
<style lang="scss">
.rgd-box-inner {
  margin-bottom:20px;
}
.rd-table-cont {
  .rd-table-row{
    //display:flex;
    padding:10px;
    /*border-bottom:1px solid #ccc;*/
    margin-bottom:5px;
  }
  .rd-table-row.highlight{
    border:1px solid #f08028;
    border-radius: 7px;
    background-color:#fff;
  }
  .rd-table-col{
    width:100%;
    font-weight: 500;
  }
  .rd-text {
    display: flex;
    padding: 10px 14px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid var(--Main-Color-Main-100, #003451);
    background: var(--Base-White, #FFF);

    /* Shadow / xs */
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    color: var(--Main-Color-Main-100, #003451);
    font-variant-numeric: lining-nums proportional-nums;

    /* Title Styles/Title Small */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
  }
  .rd-table-col.rd-head{
    color: #0B2C3E;
    font-variant-numeric: lining-nums proportional-nums;

    /* Title Styles/Title Medium */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }
  width:100%;
  border-radius: 7px;
  /*border:1px solid #ccc;*/
  padding:20px 40px;
/*  background-color:#f2f2f2;*/
}
.coupon-reg{
  h3{
    margin-bottom:20px;
    color: var(--Main-Color-Main-100, #003451);
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }
  p {
    margin-bottom:0;
    color: var(--Main-Color-Main-100, #003451);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
border-radius: 7px;
/*box-shadow:0px 0px 10px 1px rgba(0,0,0,.1);*/
padding:20px;
}
.coupon-reg-inner{
  display:flex;
  flex-wrap: wrap;
  flex-direction: flex-start;
}
.cr-col{
&:not(:last-child){
  margin-right:20px;
}
align-self:center;
}
.rgd-box {
  .status {
    padding: 10px 40px;
    text-align: center;
    justify-content: center;
  }
  h3 {
    color: var(--Main-Color-Main-100, #003451);
    font-variant-numeric: lining-nums proportional-nums;

    /* Title Styles/Title Large */
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 155.556% */
  }
  .rgd-box-head{
    i {
      color:#8bc451;
    }
    text-align: center;
    /*border-bottom:1px solid #ccc;*/
    padding-bottom:15px;
  }
  .rgd-box-head.denied{
    i {
      color:#c32429;
    }
  }
border-radius: 7px;
/*box-shadow:0px 0px 10px 5px rgba(139,196,81,.3);*/
/*margin-bottom:20px;
padding:20px;*/
}
/*.rgd-box.denied{
  box-shadow:0px 0px 10px 5px rgba(195,36,41,.3);
}*/
.product-create-form {
  width:100%;
}
.pcf-divider {
  width:100%;
  border:1px solid #000;
  margin:10px 0;
}
.pcf-feature-area {
  width:100%;
  display:flex;
  flex-wrap: wrap;
  justify-content: flex-start;

}
.pcf-feature {
  display:flex;
  width:100px;
  height: 100px;
  border-radius: 7px;
  border:2px solid #ccc;
  background-color:#fff;
  color:#000;
  align-items: center;
  justify-content: center;
  margin:10px;
  text-align: center;
  padding:10px;
  font-size:14px;
  cursor:pointer;
  transition:all .2s ease;
  font-weight: 600;
}
.pcf-add-feature {
  font-size:44px;
  font-weight: 600;
}
.pcf-feature:hover {
  transform:translateY(-5px);
}
.pcf-price-edit-area {
  margin:20px 0;
  width:50%;
}
.pcf-price-item {
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  color:#000;
  font-weight: 600;
  padding:10px;
}
.pcf-price-item:nth-child(odd){
  background-color:#f5f5f5;
}
.pcf-price-total {
  border-radius:7px;
  padding:10px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  box-shadow:0px 0px 5px 3px rgba(0,0,0,.1);
  margin:20px 0;
}
.pcf-item-price input {
  width:100px;
  border:1px solid orange;
  margin:0;
  text-align:right;
  padding:5px;
}
.pcf-price-total .pcf-item-name {
  font-size:22px;
  font-weight: bold;
}
.pcf-assign {
  div{
    width:45%;
  }
  select {
    border:1px solid #ccc;
    padding:5px;
    width:100%;
  }
  margin:20px 0;
  display:flex;
  width:100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
</style>
<style lang="scss">
.ef-row{
  width:100%;
}
.edit-feature-form{
  display:flex;
  width:100%;
  justify-content: flex-start;
}
.ef-edit {
  padding-bottom:10px;
  border-bottom:1px solid #000;
}
.ef-feature{
  .edit-col:first-child{
    width:70%;
  }
  .edit-col:nth-child(2){
    width:30%;
  }
  width:100%;
  display:flex;
  flex-wrap:wrap;
  align-items:center;
}
.ef-col {
  &:first-child{
    border-right:1px solid #000;
    padding-right:20px;
  }
  &:last-child{
    padding-left:20px;
  }
width:50%;
}
.ef-input {
  border:1px solid #ccc;
  padding:5px;
  width: 100%;
}
.ef-inner-row {
  display:flex;
  justify-content: flex-start;
  margin:10px 0;
  flex-wrap: wrap;
}
.ef-row-inner-col {
  width:50%;
}
.ef-single-row .ef-row-inner-col {
width:100%;
}
.ef-label {
  font-weight:600;
}
.ef-textarea {
  resize: none;
  height:200px;
}
</style>
<style lang="scss">
.rewards-table{
  width:100%;
}
.rt-top-body {
  border: 1px solid #C7C7C7;
  border-radius: 10px;
}
.rt-heading {
  display:flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items:center;
  font-weight: 700;
}
.rt-body {
  display:flex;
  flex-wrap:wrap;
  justify-content: flex-start;
  align-items:center;
  font-size:14px;
  border-radius: 7px;

  transition:all .2s ease;
  border-bottom: 1px solid #C7C7C7;
}
.rt-h-col, .rt-b-col{
  width:13.66%;
  text-align: center;
  padding:10px;
  display:flex;
  align-items:center;
  justify-content:center;
}
.rt-h-col {
  color: var(--Main-Color-Main-70, #0077B4);
  font-variant-numeric: lining-nums proportional-nums;

  /* Paragraph Styles/Paragraph Medium */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
}
.rt-b-col {
  h4{
    text-overflow: ellipsis;
    overflow:hidden;
    white-space: nowrap;
    font-weight: normal;
    font-size:14px;
    transition:all .2s ease;
    &:hover{
      overflow:visible;
      background-color:#f2f2f2;
      padding:5px;
      border:1px solid #c3c3c3;
      border-radius: 7px;
      z-index: 999;
    }
  }
  height:70px;
  min-width: 0;
}
@media (max-width:1422px) {
  .rt-b-col{
    .al-button{
      padding: 4px 7px;
      font-size:12px;
    }
  }
}
@media (max-width:1321px){
  .rt-h-col{
    height:71px;
  }
}
.al-input {
  color: var(--Cold-Gray-Cold-Gray-20, #C8D2D2);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}
.sub-sidebar {
  background-color: #013A5A !important;
  width: 217px !important;
  float: left;
  min-height: 1550px;

}
.sub-sidebar > ul > li {
  font-size: 12px;
  width: 217px;
  padding: 22px 20px !important;
}
.sub-sidebar > .side-menu >  li:hover {
  background-color: #00527A;
}
.workspace-campaign-detail {
  background-color: transparent;
  border: 0;
}
.sub-side-menu {
  margin: 0 !important;
}
.sub-side-menu-sub {
  padding: 20px 0;
}
.sub-side-menu-sub > li {
  margin-left: 40px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 400;
  list-style-type: disc;
}
.sub-side-menu-sub > li:hover {
  color: #fff;
  cursor: pointer;
}
.sub-side-menu-sub > .active {
  color: #fff;
}
.section-heading > h2 {
  font-size: 24px;
  color: #003451;
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H2 */
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  line-height: 40px; /* 142.857% */
}
.section-heading {
  width: 58% !important;
  border-bottom: none !important;
  padding-left: 30px;
  padding-bottom: 20px;
}
.tab-inner-left {
  width: 100%;
}
.flex-area {
  padding: 0 25px 20px 30px;
}
.form-module {
  padding: 25px;
}
.form-module h5 {
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding-bottom: 10px;
}
.rt-heading>.rt-h-col {
  color: var(--Main-Color-Main-70, #0077B4);

  /* Paragraph Styles/Paragraph Large */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}

.modal-content {
  border-radius: 20px;
  background: #FFF;
  box-shadow: 0px 0px 20px 0px rgba(0, 52, 81, 0.20);
}
.modal-header {
  margin: 10px 40px;
  max-width: 430px;
  padding: 1rem 0 !important;
}
.modal-header .close {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 1px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin: 5px;
}
.modal-body {
  padding: 0;
}
.modal-title {
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H3 */
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
}
.denied>.status>div{
  svg{
    display: flex;
    width: 90px;
    height: 90px;
    padding: 13px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 37.333px;
    border: 10.667px solid #FFF6F6;
    background: #FFE3E3;
  }
  justify-content: center;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
}


.success>.status>div{
  svg{
    display: flex;
    width: 90px;
    height: 90px;
    padding: 13px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 37.333px;
    border: 10.667px solid var(--Success-50, #ECFDF3);
    background: var(--Success-100, #D1FADF);
  }
  justify-content: center;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
}
</style>
